import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Contracts from './components/Contracts';

const contracts = (props, { t }) => (
  <Container>
    <Contracts {...props} />
  </Container>
);

contracts.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(contracts);
